export const GA_SCREEN_LISTING = 'Listing';
export const GA_SCREEN_HOMEPAGE = 'Homepage';
export const GA_SCREEN_LANDING_PAGE = 'LandingPage';
export const GA_SCREEN_FRONT_PAGE = 'FrontPage';
export const GA_SCREEN_ENTRY_PAGE = 'Entrypage';
export const GA_SCREEN_PRODUCT = 'Product';
export const GA_SCREEN_MAGAZINE = 'Magazine';
